var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        no: "dialog",
        visible: _vm.innerVisible,
        title: _vm.$t("queryJob.deliveryAgent"),
        width: _vm.$selectByLang("400px", "430px"),
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          attrs: {
            "label-width": _vm.$selectByLang("70px", "100px"),
            "label-position": "right"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("queryJob.deliveryAgent") + ":" } },
            [
              _c("el-input", {
                attrs: { no: "deliveryRemark", type: "textarea", rows: 5 },
                model: {
                  value: _vm.deliveryRemark,
                  callback: function($$v) {
                    _vm.deliveryRemark = $$v
                  },
                  expression: "deliveryRemark"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "Confirm", type: "primary" },
              on: { click: _vm.clickHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "Cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }